import { Component, inject, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { ENVIRONMENT } from "src/environments/environment";
import { KeylistenerService } from "src/services/keylistener.service";
import { v4 as uuid } from "uuid";

export enum ComponentStates {
  STARTED,
  FINISHED,
}

export interface ComponentState {
  id: string;
  state: ComponentStates;
}

@Component({
  standalone: true,
  selector: "app-default",
  changeDetection: ChangeDetectionStrategy.Eager,
  template: "",
})
export class DefaultComponent implements OnDestroy {
  public readonly uuid = uuid();

  public status$: BehaviorSubject<ComponentStates>;
  public subscriptions: Subscription;
  public keylistener = inject(KeylistenerService);
  public keylistener_ids: string[];

  public constructor() {
    this.status$ = new BehaviorSubject<ComponentStates>(ComponentStates.STARTED);
    this.subscriptions = new Subscription();
    this.keylistener_ids = [];
  }

  /**
   * Add one or multiple subscriptions
   * @param subscriptions
   */
  public addSubscription(...subscriptions: Subscription[]): void {
    for (const s of subscriptions) this.subscriptions.add(s);
  }

  public addKeyListeners(...keylisteners: Parameters<KeylistenerService["add"]>[]): void {
    for (const k of keylisteners) {
      this.keylistener_ids.push(this.keylistener.add(...k));
    }
  }

  /**
   * Unsubscribe all added subscriptions
   */
  public ngOnDestroy(): void {
    for (const key of this.keylistener_ids) {
      this.keylistener.remove(key);
    }
    this.subscriptions.unsubscribe();
  }

  /**
   * Logger for html
   * @param x
   */
  public log(...x: unknown[]): void {
    if (ENVIRONMENT.DEBUG) {
      console.log(...x);
    }
  }

  public canDeactivate(): boolean | Promise<boolean> {
    return true;
  }
}
